import "@hotwired/turbo-rails"
import "flowbite"
import "./controllers"
import "./lib/confirm_dialog"
